import { useCallback } from 'react';

import { useSelector } from 'react-redux';

import { selectChannels } from 'store/programs/selectors';

function useChannelsSearch() {
    const channels = useSelector(selectChannels);

    return useCallback(
        (searchQuery: string) => {
            const searchText = searchQuery.toLowerCase();

            return channels.filter(({ editorial: { longName } }) =>
                longName.toLowerCase().includes(searchText),
            );
        },
        [channels],
    );
}

export default useChannelsSearch;
